module.exports = __webpack_public_path__ + "static/media/1012860.40f3b52e.png";